module.exports = __webpack_public_path__ + "static/media/dep9.c6dacfb9.jpg";